export * from './component';



// WEBPACK FOOTER //
// ./src/components/mosaic/index.ts